export default __webpack_public_path__ + "static/media/875b4bf671abd7898e9f169ec9160a4b9cdfee3bb63c2078d7f9ce0cca8a7a26.9f111d15.svg";